import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Printer, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import * as thermal from "../lib/escpos";

// POS: pulsantino stampante termica — tocco = ricollega l'ultima stampante, tocco lungo / clic destro = scollega
export default function ThermalQuickButton() {
  const [st, setSt] = useState({ connected: thermal.isConnected(), name: thermal.deviceName() });
  const [busy, setBusy] = useState(false);
  useEffect(() => thermal.onStatus(setSt), []);
  if (!thermal.isSupported()) return null;
  const go = async () => {
    if (busy) return;
    if (st.connected) { toast.info(`Stampante ${st.name} già collegata`); return; }
    setBusy(true);
    try { const n = await thermal.reconnect(); toast.success(`Stampante ${n} collegata`); }
    catch (e) { if (e?.name !== "NotFoundError") toast.error(e?.message || "Collegamento stampante non riuscito"); }
    finally { setBusy(false); }
  };
  const off = (e) => { e.preventDefault(); if (st.connected) { thermal.disconnect(); toast.success("Stampante scollegata"); } };
  let timer;
  return (
    <Button data-testid="counter-thermal-button" onClick={go} onContextMenu={off}
      onTouchStart={() => { timer = setTimeout(() => off({ preventDefault() {} }), 700); }} onTouchEnd={() => clearTimeout(timer)} onTouchMove={() => clearTimeout(timer)}
      variant="outline" className="border-zinc-800 h-11 relative" title={st.connected ? `Stampante ${st.name} collegata · clic destro / tocco lungo per scollegare` : st.name ? `Ricollega ${st.name}` : "Collega stampante termica"}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Printer className="h-4 w-4" />}
      <span className={`absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full ring-2 ring-zinc-950 ${st.connected ? "bg-emerald-400" : "bg-zinc-500"}`} data-testid="counter-thermal-dot" />
    </Button>
  );
}
